import { IMAGE_PATHS } from 'constants/imagePaths';
import { Form, Image } from 'react-bootstrap';
import ActionMenu from '../ActionMenu';
import useTranslate from 'hooks/useTranslate';
import Loader from 'components/Common/Loader';
import useResumeStore from 'store/resume';
import './styles.scss';
import { S3_URL } from 'constants';

const Profile = ({
	data,
	slug,
	handleRemoveClick,
	handleFileChange,
	isUploading,
	handleTitleChange,
}: any) => {
	const resumeData: any = useResumeStore((state) => state?.resumeData);
	const { translate } = useTranslate();

	return (
		<div className="profile-img">
			<Form>
				<div className="build-resume-edit-header">
					<ActionMenu
						data={data}
						handleRemoveClick={handleRemoveClick}
						slug="imageTitle"
						contentSlug={slug}
						handleTitleChange={handleTitleChange}
					/>
					<p className="mb-0 text-center">{translate('Resume.basicDetailsText')}</p>
				</div>
				<div className="build-resume-edit-fields">
					<div className="avatar-upload position-relative">
						<div className="avatar-upload-edit position-absolute end-0 bottom-0">
							<Form.Group>
								<Form.Label
									htmlFor="profilePicture"
									className="d-inline-block mb-0 rounded-circle"
								/>
								<Form.Control
									type="file"
									className="d-none"
									id="profilePicture"
									name="profilePicture"
									accept=".png, .jpg, .jpeg"
									onChange={(event) => handleFileChange({ slug, event })}
								/>
							</Form.Group>
						</div>
						<div className="avatar-upload-avatar-preview position-relative rounded-circle d-flex align-items-center justify-content-center">
							{isUploading?.[slug] ? (
								<Loader />
							) : (
								<div className="w-100 h-100 rounded-circle">
									<Image
										className="w-100 h-100 rounded-circle object-fit-cover"
										src={
											resumeData?.profilePicture
												? `${S3_URL}${resumeData.profilePicture}`
												: IMAGE_PATHS.UserDefault
										}
										alt="profile Image"
										loading="lazy"
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</Form>
		</div>
	);
};

export default Profile;
